import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

import { authInterceptor } from './interceptors/auth.interceptor';
import { authRefreshInterceptor } from './interceptors/auth-refresh.interceptor';
import { AuthSessionService } from './services/auth-session.service';
import { routes } from './app.routes';

pdfDefaultOptions.assetsFolder = 'assets';
pdfDefaultOptions.cMapUrl = () => './assets/cmaps/';
pdfDefaultOptions.standardFontDataUrl = () => './assets/standard_fonts/';
pdfDefaultOptions.wasmUrl = () => './assets/wasm/';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideHttpClient(withInterceptors([authInterceptor, authRefreshInterceptor])),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AuthSessionService],
      useFactory: (authSession: AuthSessionService) => {
        return () => authSession.initialize();
      },
    },
  ],
};
